require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-derui-bs-boilerplate.json") })
        }
      }, "path---package-unpublished-derui-bs-boilerplate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-derui-bs-boilerplate!./.cache/json/package-unpublished-derui-bs-boilerplate.json
// module id = 935
// module chunks = 231608221292675